import React from "react";
import { Box, IconButton, InputBase, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from '@mui/icons-material/Close';
import paperclipIcon from "../../assets/icons/paperclip.png";

const SearchBar = ({ 
  searchValue, 
  onInputChange, 
  onSend, 
  inputRef, 
  numLines,
  isMobile,
  fileInputRef,
  onFileChange,
  onAttachClick,
  imagePreview,
  onRemoveImage
}) => {
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSend();
    }
  };

  // Check if submit should be disabled
  const isSubmitDisabled = imagePreview && !searchValue.trim();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        bgcolor: "#e1ecc8",
        borderRadius: numLines > 1 ? "21px" : "200px",
        p: isMobile ? 0.5 : 1,
        width: "100%",
        maxWidth: isMobile ? "90vw" : "800px",
        minHeight: "60px",
        mx: "auto",
        transition: "border-radius 0.3s ease-in-out",
        position: "relative"
      }}
    >
      <IconButton
        sx={{ p: 1, color: "#516d4f", alignSelf: "center" }}
        onClick={onAttachClick}
      >
        <img 
          src={paperclipIcon} 
          alt="Attach" 
          style={{ 
            width: isMobile ? 24 : 28, 
            height: isMobile ? 24 : 28 
          }} 
        />
      </IconButton>
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={onFileChange}
        style={{ display: "none" }}
      />
      {imagePreview && (
        <Box sx={{ 
          mt: 1, 
          textAlign: "center",
          position: "relative",
          display: "inline-block"
        }}>
          <img
            src={imagePreview}
            alt="Preview"
            style={{ 
              maxWidth: "70px", 
              maxHeight: "50px", 
              borderRadius: "5px",
              display: "block"
            }}
          />
          <IconButton
            onClick={onRemoveImage}
            size="small"
            sx={{
              position: "absolute",
              top: -8,
              right: -8,
              bgcolor: "#344b35",
              width: "20px",
              height: "20px",
              padding: "2px",
              '&:hover': {
                bgcolor: "#2a3c2a",
              },
            }}
          >
            <CloseIcon sx={{ 
              color: "#ffffff", 
              fontSize: "16px"
            }} />
          </IconButton>
        </Box>
      )}

      <InputBase
        value={searchValue}
        onChange={onInputChange}
        onKeyPress={handleKeyPress}
        inputRef={inputRef}
        placeholder={imagePreview ? "Text description required when uploading an image" : "Type your search..."}
        inputProps={{
          inputMode: "text",
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: "true"
        }}
        sx={{
          flex: 1,
          fontSize: isMobile ? "1.1rem" : "1.3rem",
          color: "#516d4f",
          maxHeight: isMobile ? "150px" : "250px",
          overflowY: "auto",
          whiteSpace: "pre-wrap",
          padding: "13px",
          display: "flex",
          alignItems: "center",
          height: "100%",
          '& .MuiInputBase-input::placeholder': {
            color: imagePreview && !searchValue ? '#c74f4f' : '#516d4f',
            opacity: 0.7,
            fontSize: imagePreview ? (isMobile ? "0.9rem" : "1.1rem") : (isMobile ? "1.1rem" : "1.3rem"),
          }
        }}
        multiline
        minRows={1}
        maxRows={isMobile ? 3 : 5}
      />
      <IconButton
        disabled={isSubmitDisabled}
        sx={{ 
          p: 0.8, 
          color: isSubmitDisabled ? '#a0a0a0' : '#516d4f', 
          alignSelf: "center",
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
            color: '#a0a0a0',
            cursor: 'not-allowed'
          }
        }}
        onClick={onSend}
      >
        <SendIcon fontSize={isMobile ? "medium" : "large"} />
      </IconButton>

      {isSubmitDisabled && (
        <Typography
          sx={{
            position: 'absolute',
            bottom: -24,
            right: 0,
            color: '#c74f4f',
            fontSize: '12px',
            fontStyle: 'italic'
          }}
        >
          Please add text description
        </Typography>
      )}
    </Box>
  );
};

export default SearchBar;
